module.exports = __webpack_public_path__ + "img/Knacker_grillen_2019.1fa05f60.jpg";